import { render, staticRenderFns } from "./LotChurchListComponent.vue?vue&type=template&id=41b7571c&scoped=true&"
import script from "./LotChurchListComponent.vue?vue&type=script&lang=js&"
export * from "./LotChurchListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b7571c",
  null
  
)

export default component.exports